import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-cloud-tilebanner',
    templateUrl: './block-cloud-tilebanner.component.html',
})

export class BlockCloudTileBanner extends BlockAbstractComponent implements OnInit {

    parseImagePath(blockImagePath: string) {
        if (window.location.host === 'cloudacademy.paloaltonetworks.com') {
            return 'url(https://benefits.paloaltonetworks.com' + blockImagePath + ')'
        } else {
            return 'url(' + blockImagePath + ')'
        }
    }
}
